import { computed, reactive } from 'vue'

type LayoutConfig = {
  preset: string
  primary: string
  surface: string | null
  darkTheme: boolean
  menuMode: 'static' | 'overlay' | string
}

type LayoutState = {
  staticMenuDesktopInactive: boolean
  overlayMenuActive: boolean
  profileSidebarVisible: boolean
  configSidebarVisible: boolean
  staticMenuMobileActive: boolean
  menuHoverActive: boolean
  activeMenuItem: unknown
}

const layoutConfig = reactive<LayoutConfig>({
  preset: 'Aura',
  primary: 'emerald',
  surface: null,
  darkTheme: false,
  menuMode: 'static',
})

const layoutState = reactive<LayoutState>({
  staticMenuDesktopInactive: false,
  overlayMenuActive: false,
  profileSidebarVisible: false,
  configSidebarVisible: false,
  staticMenuMobileActive: false,
  menuHoverActive: false,
  activeMenuItem: null,
})

export function useLayout() {
  const setActiveMenuItem = (item: any) => {
    layoutState.activeMenuItem = item?.value ?? item
  }

  const toggleMenu = () => {
    if (window.innerWidth > 991) {
      layoutState.staticMenuDesktopInactive = !layoutState.staticMenuDesktopInactive
    } else {
      layoutState.staticMenuMobileActive = !layoutState.staticMenuMobileActive
    }
  }

  const closeMenu = () => {
    layoutState.staticMenuDesktopInactive = true
    layoutState.staticMenuMobileActive = false
  }

  const isSidebarActive = computed<boolean>(
    () => layoutState.staticMenuMobileActive || !layoutState.staticMenuDesktopInactive,
  )

  const isSidebarExpanded = computed<boolean>(
    () => !layoutState.staticMenuDesktopInactive || layoutState.staticMenuMobileActive,
  )

  return {
    layoutConfig,
    layoutState,
    toggleMenu,
    closeMenu,
    isSidebarActive,
    isSidebarExpanded,
    setActiveMenuItem,
  }
}
